import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import { useSelector } from "react-redux";

const Footer = () => {
  const { adminInfo } = useSelector((state) => state.adminLoginReducer);

  return (
    <>
      {adminInfo ? (
        <div className={styles.container}>
          <Link to="/new-deliveries">
            <i className={styles.icon + " fas fa-image"}></i>
          </Link>
          <Link to="/earnings">
            <i className={styles.icon + " fas fa-home"}></i>
          </Link>
          <Link to="/my-account">
            <i className={styles.icon + " fas fa-user"}></i>
          </Link>
        </div>
      ) : (
        <div className={styles.container}>
          <Link to="/my-deliveries">
            <i className={styles.icon + " fas fa-image"}></i>
          </Link>
          <Link to="/">
            <i className={styles.icon + " fas fa-home"}></i>
          </Link>
          <Link to="/my-account">
            <i className={styles.icon + " fas fa-user"}></i>
          </Link>
        </div>
      )}
    </>
  );
};

export default Footer;
